import { render, staticRenderFns } from "./PhoneDialog.vue?vue&type=template&id=24d964ee&lang=pug"
import script from "./PhoneDialog.vue?vue&type=script&lang=js"
export * from "./PhoneDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports